import React from "react";
import { Typography } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';

export interface ServiceCategory {
    title: string;
    services: string[];
    imageUrl?: string; // optional image URL
}

interface ServiceBlockProps {
    data: ServiceCategory[];
}

const ServiceBlock: React.FC<ServiceBlockProps> = ({ data }) => {
    return (
        <div className="pb-7" >
            <div className="space-y-6 p-3 flex flex-wrap justify-center mx-auto gap-2">
                {data.map((category, idx) => (
                    <div
                        key={idx}
                        className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 items-start md:items-center"
                    >
                        {/* Image placeholder */}
                        <div
                            className="w-full md:w-[250px] h-[200px] bg-gray-300 rounded-lg flex-shrink-0 flex items-center justify-center font-bold text-gray-400"
                        >
                            {category.imageUrl ? (
                                <img
                                    src={category.imageUrl}
                                    alt={category.title}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            ) : (
                                "Image Placeholder"
                            )}
                        </div>

                        {/* Text content */}
                        <div className="space-y-2 flex-1">
                            <Typography variant="h5" component="h4">{category.title}</Typography>

                            {category.services.map((service, index) => (
                                <div key={index} className="flex items-center space-x-2  md:min-w-120 min-w-0">
                                    <DoneIcon sx={{ color: "#1b9300", fontSize: 20 }} />
                                    <Typography variant="h6" component="h5" className="!my-0 p-0">{service}</Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServiceBlock;
